import React, { Fragment } from "react";
import camera_tab_data from "../../../assets/mockedData/camera_tab_data";
import stereo_camera_tab_data from "../../../assets/mockedData/stereo_camera_tab_data";
import delta_tab_data from "../../../assets/mockedData/delta_tab_data";
import jetson_nano_tab_data from "../../../assets/mockedData/jetson_nano_tab_data";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import Tabs from "../../../components/Tabs/Tabs";
import { DeviceTypeId } from "../../../constants/deviceTypes";

type DeviceMenuProps = {
  typeId?: number;
};

const DeviceMenu = (props: DeviceMenuProps) => {
  const jetsonNanoTabData = jetson_nano_tab_data;
  const deltaTabData = delta_tab_data;
  const cameraTabData = camera_tab_data;
  const stereoCameraTabData = stereo_camera_tab_data;
  const typeId = props.typeId;

  const renderDeviceMenu = (typeId: number) => {
    switch (typeId) {
      case DeviceTypeId.HOST:
        return <Tabs data={jetsonNanoTabData} />;
      case DeviceTypeId.CAMERA:
        return <Tabs data={cameraTabData} />;
      case DeviceTypeId.STEREO_CAMERA:
        return <Tabs data={stereoCameraTabData} />;
      case DeviceTypeId.PLC:
        return <Tabs data={deltaTabData} />;
      case DeviceTypeId.ROBOT_ARM:
        return <Tabs data={deltaTabData} />;
      default:
        return <Tabs data={deltaTabData} />;
    }
  };

  return typeId ? (
    <Fragment>{renderDeviceMenu(typeId)}</Fragment>
  ) : (
    <LoadingSpinner/>
  );
};
export default DeviceMenu;
